const offersSlider = document.querySelector('.offers__slider');

const defaultSliderOptions = {
    // speed: 2200,
    watchOverflow: true,
    observer: true,
    resizeObserver: true,
    autoHeight: false,
    speed: 1000,
    grabCursor: true,
    spaceBetween: 40,
};
const initSlider = (elem) => {
    if (!elem) return;

    const nextButton = elem.querySelector('.offers__slider-button--next');
    const prevButton = elem.querySelector('.offers__slider-button--prev');

    const sliderOptions = {
        ...defaultSliderOptions,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,

            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1325: {
                slidesPerView: 3,
                spaceBetween: 40,
            }
        },
    };

    if (elem.hasAttribute('data-autoplay')) {
        sliderOptions.autoplay = {
            delay: 2200,
            disableOnInteraction: false
        };

        sliderOptions.loop = true;
    }

    const swiper = new Swiper(elem, sliderOptions);

    window.addEventListener('resize', swiper.updateSlides());
};

if (offersSlider) {
    initSlider(offersSlider);
}